import {
  AfterViewInit,
  ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef,
  ViewChild
} from '@angular/core';
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions";
import {DatePipe, DecimalPipe} from "@angular/common";

import * as d3 from 'd3-shape';
import * as _ from 'lodash';
import {LineChartComponent} from "@swimlane/ngx-charts";

@Component({
  selector: 'vb-temperature-log-chart',
  templateUrl: './temperature-log-chart.component.html',
  styleUrls: ['./temperature-log-chart.component.css']
})
export class TemperatureLogChartComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit, OnChanges {

  @Input()
  logEntries = [];

  criticalEntries = [];

  @Input()
  sensor;

  tempChartVisible: boolean = true;

  @ViewChild('tempChart')
  private tempChart: LineChartComponent;

  @ViewChild('tempSeriesTooltipTemplate')
  tempSeriesTooltipTemplate: TemplateRef<any>;

  @ViewChild('tempTooltipTemplate')
  tempTooltipTemplate: TemplateRef<any>;

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  label = "Insgesamt";
  legendTitle = "Legende";
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Zeitpunkt';
  showYAxisLabel = true;
  yAxisLabel = '° C';
  timeline = true;
  autoScale = false;
  round = true;
  curve = d3.curveNatural;
  referenceLines = [];
  showRefLines = true;
  showRefLabels = true;

  xAxisTickFormatting = (label) => {
    return this.datePipe.transform(label, 'short');
  };

  yAxisTickFormatting = (label) => {
    return this.numberPipe.transform(label, '1.1-1');
  };

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private datePipe: DatePipe, private numberPipe: DecimalPipe) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }


  ngAfterViewInit() {
    super.ngAfterViewInit();

    if (this.tempSeriesTooltipTemplate) {
      this.tempChart.seriesTooltipTemplate = this.tempSeriesTooltipTemplate;
    }

    if(this.tempTooltipTemplate) {
      this.tempChart.tooltipTemplate = this.tempTooltipTemplate;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.sensor) {
      this.yAxisLabel = this.sensor.temperature_unit;
      this.referenceLines = [
        {
          name: 'MAX',
          value: this.sensor.max_limit
        },
        {
          name: 'MIN',
          value: this.sensor.min_limit
        }
      ];
    }

    if (changes.logEntries) {

      // Filter critical entries for highlighting
      this.criticalEntries = _.cloneDeep(this.logEntries)
        .map(e => {
          return {
            'name': e.name,
            'series': e.series.filter(s => s.highlight && s.highlight == true)
          }
        });
    }
  }

  getToolTipText(tooltipItem) {
    var result = '';
    if (tooltipItem.series !== undefined) {
      result += tooltipItem.series;
    }
    else {
      result += '???';
    }
    result += ': ';
    if (tooltipItem.value !== undefined) {
      result += this.numberPipe.transform(tooltipItem.value) + ' °C';
    }
    if (tooltipItem.min !== undefined || tooltipItem.max !== undefined) {
      result += ' (';
      if (tooltipItem.min !== undefined) {
        if (tooltipItem.max === undefined) {
          result += '≥';
        }
        result += tooltipItem.min.toLocaleString();
        if (tooltipItem.max !== undefined) {
          result += ' - ';
        }
      }
      else if (tooltipItem.max !== undefined) {
        result += '≤';
      }
      if (tooltipItem.max !== undefined) {
        result += tooltipItem.max.toLocaleString();
      }
      result += ')';
    }
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/app/sensors/components/temperature-log-chart/temperature-log-chart.component.ts